import Controller from "csi/action/Controller";
import FormData from "csi/action/FormData";
import csi from "csi/main";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

const SELECT_PRODUCT_HIERARCHY_PAGE = 0;
const SELECT_PRODUCT_HIERARCHY_FOLDERS_PAGE = 1;

const SharedTeamSelectProductHierarchyFolders = declare([Controller, ActionControllerMixin], {

	/** @property {FormData} _fdHierarchy -- ProductHierarchy veiw FormData */
	_fdHierarchy: null,

	/** @property {FormData} _fdHierarchyFolders -- ProductHierarchyFolder veiw FormData */
	_fdHierarchyFolders: null,

	/**
	*@override
	* Prepare the data and pass it into the next page
	*/
	onNextPage(wizard, currentPage, nextPage, bFinish) {
		let fd = this.m_formData;
		const indexOfPage = wizard.getIndexOfPage(nextPage);
		let bRefresh = false;
		if (indexOfPage == SELECT_PRODUCT_HIERARCHY_PAGE) {
			fd = this._fdHierarchy = this._fdHierarchy || new FormData(this);
			fd.m_bRequireOne = true;
			fd.m_bSelectOne = true;
		} else if (indexOfPage == SELECT_PRODUCT_HIERARCHY_FOLDERS_PAGE) {
			const productHierarchy = wizard.getFormDataFromPage(currentPage).getSelectedNode();

			// initialize form data
			fd = this._fdHierarchyFolders = this._fdHierarchyFolders || this.m_formData;
			if (fd.getNode() != productHierarchy) {
				fd.setNode(productHierarchy);
				fd.resetAggregations();
				fd.resetSelections();
				bRefresh = true;
			}

			fd.m_bRequireOne = true;
			fd.m_fAggregateTest = lang.hitch(this, this._canAggregate);
		}

		return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, bRefresh) : null;
	},

	/**
	 * @override
	 * Filter out ProductHierarchy that doesn't have FolderCrewLevel selected.
	 */
	getWizardViewQuery(wizard, view, index) {
		if (index == SELECT_PRODUCT_HIERARCHY_PAGE) {
			return new Query().RefAttr("FolderCrewLevel", xml.OP_NOT_EQUALS, csi.EMPTY_URL, "Child:Subtype/Child:Settings");
		}
		return null;
	},

	/**
	 * Return true if the Hierarchy Folder is not using this Shared Team
	 * @param {Context} ctx
	 * @param {FormData} fd
	 * @return {boolean}
	 */
	_canAggregate(ctx, fd) {
		const sharedCrew = this.getNode()?.Crew;
		if (!sharedCrew) {
			return false;
		}

		const folderCrew = this.m_cache.getNode(ctx.getNode().Crew);
		const folderCrewParentCrew = folderCrew?.ParentCrew;
		return !folderCrewParentCrew || !folderCrewParentCrew.includes(sharedCrew);
	},
});

export = SharedTeamSelectProductHierarchyFolders;